import { Box, Typography } from '@mui/material';
import { concat, get } from 'lodash';
import React, { FC } from 'react';
import CreateTable from 'src/components/ui-component/form-component/create-form/CreateTable';
import MarkdownRenderer from 'src/components/ui-component/markdown-renderer/MarkdownRenderer';
import { useApplication } from 'src/context/ApplicationContext';
import { FOERDERPROGRAMM_ERKLAERUNG_UND_UNTERLAGEN_MA_PATHS } from 'src/lib/constants/componentsPath';
import { FORM_FIELDS_TYPES, PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import { ForceTrue } from 'src/lib/validation/ValidationTypes';
import { addIndexesToPath } from 'src/utils/helper';

// import schemas
import MittelabrufSchema from 'src/lib/paths/mittelabruf_FULL_Paths.json';
import ApplicationHeading from 'src/pages/private/online-antrag/application-heading/ApplicationHeading';
const MA_P = MittelabrufSchema.attributes;

const ErklaerungMA: FC<{}> = ({}) => {
	const { application, setApplicationProperty, readOnly } = useApplication();

	const Foerderprogramm = get(application, MA_P.Foerderantrag.schema.attributes.Foerderprogramm.path, {});

	// Dynamische Pfade basierend auf antragsTyp
	const paths = FOERDERPROGRAMM_ERKLAERUNG_UND_UNTERLAGEN_MA_PATHS;

	return (
		<>
			<ApplicationHeading title='Erklärungen' description={PLATZHALTER_TEXT} />

			{get(application, MA_P.Erklaerungen_Pflichterklaerungen.path, []).length > 0 && (
				<Box>
					<Typography variant='h5' sx={{ mb: '1rem' }}>
						{' '}
						{get(Foerderprogramm, paths.PflichtErklaerungTitel, 'Pflichterklärungen')}{' '}
					</Typography>
					<MarkdownRenderer markdown={get(Foerderprogramm, paths.PflichtErklaerungBeschreibung, '')} />

					<CreateTable
						formStruc={formStrucPflichtErklaerung(application)}
						formValues={application}
						updateFormValuesFunc={setApplicationProperty}
						readOnly={readOnly}
						size='small'
					/>
				</Box>
			)}

			{/**
			 * Platzhalter, um Abstand zwischen Pflicht- und optionalen Erklärungen zu schaffen, falls beide vorhanden sind.
			 */}
			{(
				get(application, MA_P.Erklaerungen_Pflichterklaerungen.path, []).length > 0 &&
				get(application, MA_P.Erklaerungen_Optionale_Erklaerungen.path, []).length > 0
			) ?
				<Box sx={{ mt: '2rem' }}></Box>
			:	null}

			{get(application, MA_P.Erklaerungen_Optionale_Erklaerungen.path, []).length > 0 && (
				<Box>
					<Typography variant='h5' sx={{ mb: '1rem' }}>
						{' '}
						{get(Foerderprogramm, paths.OptionaleErklaerungTitel, 'Optionale Erklärungen')}{' '}
					</Typography>
					<MarkdownRenderer markdown={get(Foerderprogramm, paths.OptionaleErklaerungBeschreibung, '')} />
					<CreateTable
						formStruc={formStrucOptionaleErklaerungen(application)}
						formValues={application}
						updateFormValuesFunc={setApplicationProperty}
						readOnly={readOnly}
						size='small'
					/>
				</Box>
			)}
		</>
	);
};

export default ErklaerungMA;

const formStrucPflichtErklaerung = (application: any) => {
	let struc: FormStrucItem[] = [];

	const pflichtErklaerungen = get(application, MA_P.Erklaerungen_Pflichterklaerungen.path, []);
	for (const [i, ele] of pflichtErklaerungen.entries()) {
		struc.push({
			fields: [
				{
					type: FORM_FIELDS_TYPES.boolean,
					path: addIndexesToPath(
						MA_P.Erklaerungen_Pflichterklaerungen.schema.attributes.Zugestimmt.path,
						[`${i}`],
						['Erklaerungen_Pflichterklaerungen'],
					),
					validation: [{ validateFunction: ForceTrue }],
				},
				{
					type: FORM_FIELDS_TYPES.label,
					path: 't.t',
					label: get(ele, 'Inhalt', ''),
				},
			],
		});
	}
	return struc;
};
const formStrucOptionaleErklaerungen = (application: any) => {
	let struc: FormStrucItem[] = [];
	const optionaleErklaerungen = get(application, MA_P.Erklaerungen_Optionale_Erklaerungen.path, []);

	for (const [i, ele] of optionaleErklaerungen.entries()) {
		struc.push({
			fields: [
				{
					type: 'boolean',
					path: addIndexesToPath(
						MA_P.Erklaerungen_Optionale_Erklaerungen.schema.attributes.Zugestimmt.path,
						[`${i}`],
						['Erklaerungen_Optionale_Erklaerungen'],
					),
				},
				{
					type: 'label',
					path: 't.t',
					label: get(ele, 'Inhalt', ''),
				},
			],
		});
	}
	return struc;
};

export const getFormStrucErklaerungMA = (application: any) => {
	return concat(formStrucPflichtErklaerung(application));
};
